<template>
  <v-container fluid class="px-0">
     <h3 class="mb-1" style="display: flex">Išraše rodomi failai</h3>
    <v-card class="mb-1" outlined>
        <!-- form  -->
        <v-card-text class="pb-0">
          <v-data-table
            class="mb-4 custom-table"
            :loading="contentloading"
            :headers="headers"
            :items="documentList"
            :hide-default-footer="true"
            :header-props="{
              sortByText: $t('Rūšiuoti pagal'),
            }"
          >
            <!-- custom templates -->
            <template #[`item.show_at_statement`]="{ item }">
              <v-checkbox v-model="item.show_at_statement" @change="changeValue" :disabled="!canChange"></v-checkbox>
            </template>
            <template #[`item.size`]="{ item }">
            <span>{{ getItemSize(item) }}</span>
            </template>
            <!--  -->
            <template #[`item.actions`]="{ item }">
              <div class="nowrap">
                <el-table-action :item="item" @downloadItem="download(item)" />
              </div>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
  </v-container>
</template>

<script>
import math from '@/mixins/math'

export default {
  name: 'StatementFiles',
  mixins: [math],
  props: {
    objectId: [String, Number],
    inJournalId: [String, Number],
    canChange: [Boolean]
  },
  data() {
    return {
      documentList: [],
      contentloading: false,
    }
  },
  computed: {
    headers() {
      return [
        {
          text: '',
          align: 'center',
          sortable: false,
          value: 'show_at_statement',
          
        },
        {
          text: this.$t('Veiksmai'),
          align: 'center',
          sortable: false,
          value: 'actions',
        },
        {
          text: this.$t('Dokumento pavadinimas'),
          align: 'start',
          value: 'original_filename',
        },
        {
          text: this.$t('Dydis'),
          align: 'start',
          value: 'size',
        },
        {
          text: this.$t('Įkėlimo data'),
          align: 'start',
          value: 'created_at',
        }
      ]
    },
  },
  watch: {
    objectId: {immediate: true,
      handler(val, oldVal) {
        this.getData()
      }
    }
  },
  methods: {
    getData() {
      this.contentloading = true
      let url;
      if (this.objectId) {
        if (this.inJournalId) {
          url = `mandates/statement-files/list/${this.objectId}/${this.inJournalId}`
        } else {
          url = `mandates/statement-files/list/${this.objectId}`
        }
      } else {
        url = `in-journals/statement-files/list/${this.inJournalId}`
      }
      if (url) {
        this.$axios
          .get(url)
          .then((res) => {
            this.documentList = res.data.files
            this.$emit('setDocumentCount', res.data.files.length || 0, res.data.files)
            this.$emit('selectedDocumentsChanged', this.documentList.filter(document => document.show_at_statement))
          })
          .catch((err) => {this.$root.$emit('DATA_ERROR', err)})
          .finally(() => {this.contentloading = false})
      }
    },
    download(item) {
      this.contentloading = true
      this.$axios
        .get(`uploads/${item.id}/download`)
        .then((res) => {
          this.openFile(res.data)
        })
        .catch((err) => {
          const errData = JSON.parse(
            Buffer.from(err.response.data).toString('utf8')
          )
          this.$root.$emit('DATA_ERROR', errData.message)
        })
        .finally(() => {
          this.contentloading = false
        })
    },
    changeValue(){
      this.$emit('selectedDocumentsChanged', this.documentList.filter(document => document.show_at_statement));
    },
    openFile(file) {
      var fileLink = document.createElement('a')
      fileLink.href = file.file
      fileLink.setAttribute(
        'download',
        this.safeFileName(file.original_filename)
      )
      document.body.appendChild(fileLink)
      fileLink.click()
    },
    getItemSize(item){
      if(item.id){
        return this.bytesToSize(item.size)
      } else {
        return item.size
      }
    },
    bytesToSize(bytes) {
      var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB']
      if (bytes == 0) return '0 Byte'
      var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)))
      return Math.round(bytes / Math.pow(1024, i), 2) + ' ' + sizes[i]
    }
  }
}
</script>
